// Thirdparty
import React, { useState, useEffect } from 'react';

const Countdown = (props) => {
  // Get props
    const {
      initialMinute = 0,
      initialSeconds = 0,
      onEnd
    } = props;

    // States
    const [minutes, setMinutes] = useState(initialMinute);
    const [seconds, setSeconds] =  useState(initialSeconds);

    // First render
    useEffect(()=>{

    let myInterval = setInterval(() => {
            if (seconds > 0) {
                setSeconds(seconds - 1);
            }
            if (seconds === 0) {
                if (minutes === 0) {
                    clearInterval(myInterval);
                    onEnd();
                } else {
                    setMinutes(minutes - 1);
                    setSeconds(59);
                }
            } 
        }, 1000)
        return ()=> {
            clearInterval(myInterval);
          };
    });

    return (
        <div style={{ color: "#11a6e1" }}>
        { minutes === 0 && seconds === 0
            ? null
            : <h1> {minutes}:{seconds < 10 ?  `0${seconds}` : seconds}</h1> 
        }
        </div>
    )
}

export default Countdown;
